// CourtTypeView.js
import React from "react";
import DynamicCard from "./DynamicComponent";
import AccountTypesTable from "../Tables/AllAccountTypes/Index";
import AccountCategoriesTable from "../Tables/AccountCategories";
import AccountSubcategoriesTable from "../Tables/AcocuntSubcategories";
import SuspendedTransactionsTable from "../Tables/SuspendedTransactions";
import AccountsTable from "../Tables/Accounts";
import BanksAccountTable from "../Tables/BankAccounts";
import BanksBranchTable from "../Tables/BankBranch";
import BanksTable from "../Tables/Banks";
import FiscalYearTable from "../Tables/FiscalYears";
import PaymentTypesTable from "../Tables/PaymentTypes";
import TaxAuthorityTable from "../Tables/TaxAuthorities";
import TaxRateTable from "../Tables/TaxRates";
import CompanyTable from "../../CompanyManagement/Company";
import RegionTable from "../../CompanyManagement/Regions";
import BranchTable from "../../CompanyManagement/Branch";
import DepartmetsTable from "../../CompanyManagement/Departments";
import AddOnsTable from "../../CompanyManagement/Add-Ons";
import AdhocEmails from "../../adhoc/adhocemail";
import CompanyAddOnTable from "../../CompanyManagement/CompanyAdd-ons";
import StorageUnitsTable from "../../CompanyManagement/StoreageUnits";
import SubscriptionPlansTable from "../../CompanyManagement/SubscriptionPlans";
import SmsSettings from "../../CompanyManagement/SmsSettings";
import CompanyEmailSettingsTable from "../../CompanyManagement/CompanyEmailSettings";
import EmailSettingsForm from "../../CompanyManagement/CompanyEmailSettings/EditableForm";
import AdhocSms from "../../adhoc/adhocsms";
import MpesaCredentialsForm from "../../CompanyManagement/MpesaSettings";
import Setups from "../../SetupManagement/LeadSetups";
import IntervalsTable from "../../SetupManagement/Intervals";
import PaymentMethodsTable from "../../SetupManagement/PaymentMethods";
import UOMTable from "../../SetupManagement/UOM";
import PurchaseOrderTable from "../../SalesManagement/PurchaseOrder";
import PurchaseOrderItemsTable from "../../SalesManagement/PurchaseOrderItems";
import SalesOrderTable from "../../SalesManagement/SalesOrder";
import SalesOrderItemsTable from "../../SalesManagement/SalesOrderItems";
import UploadLogoTable from "../../CompanyManagement/UploadLogo";
import PromotionsPage from "../../POS/promotions/promotions";
import EmailsPage from "../../POS/promotions/emails";
import CustomSMSPage from "../../POS/promotions/customSMS";
import DiscountTypesTable from "../../SetupManagement/DiscountTypes";
import CustomerTypesTable from "../../SetupManagement/CustomerTypes";
import DiscountRulesTable from "../../SalesManagement/DiscountRules";
import SizeTable from "../../SetupManagement/Size";
import ColorTable from "../../SetupManagement/Color";
import ProductCategoryTable from "../../SetupManagement/ProductCategories";
import MpesaAccountTable from "../Tables/MpesaAccoouts";
import MpesaTable from "../Tables/Mpesa";
import CashAccountTable from "../Tables/CashAccounts";
import AccountsTransfersTable from "../Tables/AccountTransfer";

export const Accounts = () => {
  return (
    <DynamicCard>
      <AccountsTable />
    </DynamicCard>
  );
};
export const AccountTypesView = () => {
  return (
    <DynamicCard>
      <AccountTypesTable />
    </DynamicCard>
  );
};

export const AccountCategoryView = () => {
  return (
    <DynamicCard>
      <AccountCategoriesTable />
    </DynamicCard>
  );
};
export const  SubcategoryView = () => {
  return (
    <DynamicCard>
      <AccountSubcategoriesTable />
    </DynamicCard>
  );
};

export const SuspendedTransactions = () => {
  return (
    <DynamicCard>
      <SuspendedTransactionsTable />
    </DynamicCard>
  );
};

export const BankAccountsView = () => {
  return (
    <DynamicCard>
      <BanksAccountTable />
    </DynamicCard>
  );
};
export const AccountBankBranchesView = () => {
  return (
    <DynamicCard>
      <BanksBranchTable />
    </DynamicCard>
  );
};
export const BanksView = () => {
  return (
    <DynamicCard>
      <BanksTable />
    </DynamicCard>
  );
};
export const FiscalYearsView = () => {
  return (
    <DynamicCard>
      <FiscalYearTable />
    </DynamicCard>
  );
};
export const PaymentTypesView = () => {
  return (
    <DynamicCard>
      <PaymentTypesTable />
    </DynamicCard>
  );
};
export const TaxAuthoritiesView = () => {
  return (
    <DynamicCard>
      <TaxAuthorityTable />
    </DynamicCard>
  );
};
export const TaxRatesView = () => {
  return (
    <DynamicCard>
      <TaxRateTable />
    </DynamicCard>
  );
};
export const Companies = () => {
  return (
    <DynamicCard>
      <CompanyTable />
    </DynamicCard>
  );
};

export const RegionsView = () => {
  return (
    <DynamicCard>
      <RegionTable />
    </DynamicCard>
  );
};

export const CompanyBranchesView = () => {
  return (
    <DynamicCard>
      <BranchTable />
    </DynamicCard>
  );
};

export const DepartmentView = () => {
  return (
    <DynamicCard>
      <DepartmetsTable />
    </DynamicCard>
  );
};

export const AddOnView = () => {
  return (
    <DynamicCard>
      <AddOnsTable />
    </DynamicCard>
  );
};

export const SubscriptionPlansView = () => {
  return (
    <DynamicCard>
      <SubscriptionPlansTable />
      {/* <SubscriptionPlansTable /> */}
    </DynamicCard>
  );
};

export const StorageUnitsView = () => {
  return (
    <DynamicCard>
      <StorageUnitsTable />
    </DynamicCard>
  );
};
export const SmsSettingsView = () => {
  return (
    <DynamicCard>
      <SmsSettings />
    </DynamicCard>
  );
};


export const MpesaSettings = () => {
  return (
    <DynamicCard>
      <MpesaCredentialsForm />
    </DynamicCard>
  );
};
export const EmailSettingsView = () => {
  return (
    <DynamicCard>
      {/* // <CompanyEmailSettingsTable /> */}
      <EmailSettingsForm />
    </DynamicCard>
  );
};
export const AdhocSmsView = () => {
  return (
    <DynamicCard>
      <CustomSMSPage />
    </DynamicCard>
  );
};
export const AdhocEmailsView = () => {
  return (
    <DynamicCard>
      <EmailsPage />
    </DynamicCard>
  );
};

export const AdhocPromotionsView = () => {
  return (
    <DynamicCard>
      <PromotionsPage />
    </DynamicCard>
  );
};
export const Intervals = () => {
  return (
    <DynamicCard>
      <IntervalsTable />
    </DynamicCard>
  );
};
export const PaymentMethods = () => {
  return (
    <DynamicCard>
      <PaymentMethodsTable />
    </DynamicCard>
  );
};
export const DiscountTypes = () => {
  return (
    <DynamicCard>
      <DiscountTypesTable />
    </DynamicCard>
  );
};
export const DiscountRules = () => {
  return (
    <DynamicCard>
      <DiscountRulesTable />
    </DynamicCard>
  );
};
export const CustomerTypes = () => {
  return (
    <DynamicCard>
      <CustomerTypesTable />
    </DynamicCard>
  );
};
export const UnitOfMeasure = () => {
  return (
    <DynamicCard>
      <UOMTable />
    </DynamicCard>
  );
};

export const PurchaseOrder = () => {
  return (
    <DynamicCard>
      <PurchaseOrderTable />
    </DynamicCard>
  );
};

export const PurchaseOrderItems = () => {
  return (
    <DynamicCard>
      <PurchaseOrderItemsTable />
    </DynamicCard>
  );
};

export const SalesOrder = () => {
  return (
    <DynamicCard>
      <SalesOrderTable />
    </DynamicCard>
  );
};

export const SalesOrderItems = () => {
  return (
    <DynamicCard>
      <SalesOrderItemsTable />
    </DynamicCard>
  );
};
export const UploadLogoView = () => {
  return (
    <DynamicCard>
      <UploadLogoTable />
    </DynamicCard>
  );
};
export const Size = () => {
  return (
    <DynamicCard>
      <SizeTable />
    </DynamicCard>
  );
};
export const Color = () => {
  return (
    <DynamicCard>
      <ColorTable />
    </DynamicCard>
  );
};
export const ProductCategory = () => {
  return (
    <DynamicCard>
      <ProductCategoryTable />
    </DynamicCard>
  );
};

export const MpesaProviders = () => {
  return (
    <DynamicCard>
      <MpesaTable />
    </DynamicCard>
  );
};

export const MpesaAccounts = () => {
  return (
    <DynamicCard>
      <MpesaAccountTable />
    </DynamicCard>
  );
};

export const CashAccounts = () => {
  return (
    <DynamicCard>
      <CashAccountTable />
    </DynamicCard>
  );
};

export const AccountsTransfers = () => {
  return (
    <DynamicCard>
      <AccountsTransfersTable />
    </DynamicCard>
  );
};

